
import AppHeader from '../components/default/AppHeader'
import AppFooter from '../components/default/AppFooter'
import gtm from '../assets/js/gtm'

export default {
  name: 'LayoutDefault',
  components: { AppFooter, AppHeader },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })

    return {
      htmlAttrs: i18nHead.htmlAttrs,
      title: this.$t('meta.title'),
      meta: [
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: '@own3d' },
        { name: 'twitter:creator', content: '@own3d' },
        { name: 'twitter:title', content: this.$t('meta.twitter.title') },
        { name: 'twitter:description', content: this.$t('meta.twitter.description') },
        { name: 'twitter:image', content: this.$asset('assets/favicons/ms-icon-150x150.png') },
        { name: 'description', content: this.$t('meta.description') },
        ...i18nHead.meta
      ],
      link: i18nHead.link
    }
  },
  computed: {
    isFrontpage () {
      return this.$route.name && this.$route.name.startsWith('index')
    },
    mainClasses () {
      if (this.$store.state.showLanguageMenu && this.$isSandbox) {
        return 'pt-44'
      } else if (this.$store.state.showLanguageMenu || this.$isSandbox) {
        return 'pt-32'
      }

      return 'pt-28'
    }
  },
  mounted () {
    gtm()
  }
}
